import React from 'react';
import { DataTable } from '../../../../ui';
import { BillingHistory, getColumns } from './Functions/GetColumns';

const BillingHistoryTab = () => {
  const history: BillingHistory[] = [
    {
      id: 'INV-001',
      date: '2024-03-01',
      amount: '$12,500.00',
      status: 'Paid',
      method: 'Visa **** 4242',
    },
    {
      id: 'INV-002',
      date: '2023-03-01',
      amount: '$12,500.00',
      status: 'Paid',
      method: 'Visa **** 4242',
    },
    {
      id: 'INV-003',
      date: '2022-03-01',
      amount: '$10,000.00',
      status: 'Paid',
      method: 'Bank Transfer',
    },
  ];

  const handleDownload = (id: string) => {
    console.log(`Downloading invoice ${id}`);
    // Implement real download logic here if needed
  };

  const columns = getColumns(handleDownload);

  return (
    <div className='space-y-8'>
      <div>
        <h1 className='text-3xl font-black text-slate-800 tracking-tighter'>
          Billing History
        </h1>
        <p className='text-slate-500 font-medium'>
          View and download your past invoices.
        </p>
      </div>

      <div className='bg-white  border border-slate-100 shadow-sm overflow-hidden'>
        <DataTable
            columns={columns}
            data={history}
            rowsPerPage={10}
            totalRecords={history.length}
            totalPages={1}
            currentPage={1}
            onPageChange={() => {}}
        />
      </div>
    </div>
  );
};

export default BillingHistoryTab;
